import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {RestService} from '../../../lib/yii2-rest/rest.service';
import {Unit} from '../../dashboard/monitoring/unit';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {FormBuilder, FormGroup} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {ClipboardService} from 'ngx-clipboard';
import {NotificationsService} from 'angular2-notifications';
import {filter} from 'rxjs/operators';

@Component({
  selector: 'app-locator-create',
  templateUrl: './locator-create.component.html',
  styleUrls: ['./locator-create.component.scss'],
  providers: [
  {
    provide: RestService,
    useClass: RestService
  },
]
})
export class LocatorCreateComponent implements OnInit, OnDestroy {
  @Input() unitObservable: Observable<Unit>;
  locatorBehaviorSubject: BehaviorSubject<any> = new BehaviorSubject(null);
  formGroup: FormGroup;
  selectItems: Array<{label: string, value: number}>;
  subscriptions: Array<Subscription> = [];
  constructor(
    protected restService: RestService,
    protected formBuilder: FormBuilder,
    protected translate: TranslateService,
    protected clipboard: ClipboardService,
    protected notif: NotificationsService,
  ) { }

  ngOnInit() {
    this.selectItems = [
      {label: this.translate.instant('1 hour'), value: 3600},
      {label: this.translate.instant('2 hours'), value: 2 * 3600},
      {label: this.translate.instant('4 hours'), value: 4 * 3600},
      {label: this.translate.instant('6 hours'), value: 6 * 3600},
      {label: this.translate.instant('12 hours'), value: 12 * 3600},
      {label: this.translate.instant('1 day'), value: 86400},
      {label: this.translate.instant('2 days'), value: 2 * 86400},
    ];
    this.formGroup = this.formBuilder.group({expireTimeSeconds: 3600});
    this.subscriptions.push(
      this.locatorBehaviorSubject.pipe(
        filter(locator => !!locator)
      ).subscribe(
        locator => {
          this.clipboard.copyFromContent(locator.link);
          this.notif.success(this.translate.instant('Locator link copied to clipboard'));
        }
      )
    );
  }
  ngOnDestroy() {
  }

  createLocator(unit) {
    this.restService.create(
      'locator',
      {
        unitId: unit.id,
        expireTimeSeconds: this.formGroup.controls.expireTimeSeconds.value
      }
    ).subscribe(
      locator => this.locatorBehaviorSubject.next(locator)
    );
  }
}
